import React, { PropsWithChildren, forwardRef } from 'react';

import { StyleSheet } from 'react-native';
import {
  KeyboardAwareScrollView,
  KeyboardAvoidingView as NCKeyboardAvoidingView,
} from 'react-native-keyboard-controller';
import type {
  KeyboardAwareScrollViewProps,
  KeyboardAwareScrollViewRef,
} from 'react-native-keyboard-controller';

import { useIsDesktopWebBreakpoint } from 'hooks/use-is-desktop-web-breakpoint';

export interface KeyboardAwareViewProps extends KeyboardAwareScrollViewProps {
  /**
   * Enables scroll behaviour while the fields are focused.
   * It is recomended to set `withScroll` to `true` if the view being wrapped
   * exceeds the screen vertical height
   *
   *
   * @type {boolean}
   * @memberof KeyboardAwareViewProps
   */
  withScroll?: boolean;
}

export const KeyboardAwareView = forwardRef<
  KeyboardAwareScrollViewRef,
  KeyboardAwareViewProps & PropsWithChildren
>(({ children, withScroll = false, showsVerticalScrollIndicator, ...rest }, ref) => {
  const isDesktop = useIsDesktopWebBreakpoint();

  if (withScroll) {
    return (
      <KeyboardAwareScrollView
        showsVerticalScrollIndicator={showsVerticalScrollIndicator ?? isDesktop}
        {...rest}
        ref={ref}
      >
        {children}
      </KeyboardAwareScrollView>
    );
  }

  return (
    <NCKeyboardAvoidingView behavior="padding" style={styles.avoidingView}>
      {children}
    </NCKeyboardAvoidingView>
  );
});

KeyboardAwareView.displayName = 'KeyboardAwareView';

const styles = StyleSheet.create({ avoidingView: { flex: 1 } });
